import _ from 'lodash';
import CredentialsApi from '../../api/CredentialsApi';
import sourcesFields from '../../constants/sourcesFields';
import featureFlag from '../../api/featureFlag';

const state = {
  eligibleForDiscountPromotion: false,
};

function _isDiscountCreds(creds) {
  const discountSourceNames = [sourcesFields.allSourceFields.discount.sourceName, sourcesFields.allSourceFields['discount-api'].sourceName];
  return _.includes(discountSourceNames, creds.sourceName);
}

const actions = {
  async initPromotions({ commit }) {
    const credentials = await CredentialsApi.fetchCredentials();
    const gotDiscountCreds = _.some(credentials, _isDiscountCreds);
    const discountPromoFeatureFlag = await featureFlag.getTreatment('discount_promotion');
    const eligibleForDiscountPromotion = gotDiscountCreds && discountPromoFeatureFlag === 'on';
    commit('setEligibleForDiscountPromotion', eligibleForDiscountPromotion);
  },
};

const mutations = {
  setEligibleForDiscountPromotion(state, isEligible) {
    state.eligibleForDiscountPromotion = isEligible; // eslint-disable-line
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/promotions.js